import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BoxedSliderField } from "web_myplann/Inspiration/Components/BoxedSliderField";
import { InspirationSheet } from "web_myplann/Inspiration/Components/InspirationSheet";
import {
	EARLY_FREEDOM_RENT_MAX,
	EARLY_FREEDOM_RENT_MIN,
	EARLY_FREEDOM_RENT_STEP,
} from "web_myplann/Inspiration/constants";
import { useResetStateOnOpen } from "web_myplann/Shared/Hooks/useResetStateOnOpen";

const R = Resources.Inspiration.EarlyFreedom.IncomeSheet;

type Props = {
	open: boolean;
	initial?: number;
	onClose: () => void;
	onSubmit: (rentNet: number) => void;
};

export const EarlyFreedomIncomeSheet: FC<Props> = ({
	open,
	initial,
	onClose,
	onSubmit,
}) => {
	const { t } = useResource();
	const [rentNet, setRentNet] = useResetStateOnOpen(
		open,
		initial ?? EARLY_FREEDOM_RENT_MIN,
	);

	return (
		<InspirationSheet
			open={open}
			onClose={onClose}
			title={t(R.title)}
			description={t(R.description)}
			primaryLabel={t(R.submit)}
			onPrimary={() => onSubmit(rentNet)}
		>
			<BoxedSliderField
				label={t(R.sliderLabel)}
				value={rentNet}
				onChange={setRentNet}
				min={EARLY_FREEDOM_RENT_MIN}
				max={EARLY_FREEDOM_RENT_MAX}
				step={EARLY_FREEDOM_RENT_STEP}
				hint={t(R.hint)}
			/>
		</InspirationSheet>
	);
};
